// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
/**
 * @private
 */
export interface ConfigurationPageMicDropdownProps {
  micGrantedDropdown: JSX.Element;
  micPermissionGranted: boolean;
  onClickEnableDevicePermission?: () => void;
  ariaLabelledby?: string;
}

/**
 * @private
 */
export const ConfigurationPageMicDropdown = (props: ConfigurationPageMicDropdownProps): JSX.Element => {
  return props.micGrantedDropdown;
};